import React, { useState } from "react"
import { navigate } from "gatsby"
import "./login-admin.css"

const LoginAdminPage = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)

  // Add required email IDs to give access for staging url
  const adminEmails = ["renuga.a@dropthought.com", "roopa.y@dropthought.com", "kent.w@dropthought.com","alain.c@dropthought.com",
  "arone@dropthought.com","selvi@dropthought.com","hema@dropthought.com","roy@dropthought.com","navin@dropthought.com","chetanaggarwal@wingmanpartners.com","ahmad@dropthought.com","marketing@dropthought.com","sabarishs@dropthought.com"]

  const handleSubmit = event => {
    event.preventDefault()

    if (adminEmails.includes(email) && password === "DTweb123$") {
      sessionStorage.setItem("adminLogin", true)
      navigate("/")
      // After 15 minutes, the user will be logged out
      setTimeout(() => {
        sessionStorage.setItem("adminLogin", false)
        navigate("/login");
      }, 15 * 60 * 1000); // 
    } else {
      sessionStorage.setItem("adminLogin", false)
      setError("Invalid email or password")
      alert("Invalid email or password")
    }
  }

  // setTimeout(() => {
  //   // Set the item in localStorage
  //   localStorage.setItem("adminLogin", false);
  // }, 30 * 60 * 1000); // 30 minutes in milliseconds

  return (
    <div>
      <div className="bg_login"></div>
      <div className="cel_block">
          <section className="login_contianer">
              <div className="dt-logo">
              </div>
              <div className="login-form-wrapper">
                  <h1 className="login-title">
                      Log in to access staging environment
                  </h1>
                  <form onSubmit={handleSubmit} className="login-form">
                      <div className="form-group">
                          <input 
                            type="text" 
                            placeholder="Enter your user name" 
                            value={email}
                            onChange={event => setEmail(event.target.value)}/>
                          <span className="icon-loginform edit"></span>
                      </div>
                      <div className="form-group">
                          <input
                            type="password" 
                            placeholder="Enter your password" 
                            value={password}
                            onChange={event => setPassword(event.target.value)}/>
                          <span className="icon-loginform passwrd"></span>
                      </div>
                      <button type="submit" className="btn purple-btn-square">Submit</button>
                  </form>
              </div>
          </section>
      </div>
    </div>
  )
}
export default LoginAdminPage